import React from 'react';
import styled from 'styled-components';

const StyledSvg = styled.svg`
  position: absolute;
  width: 84%;
  height: auto;
  bottom: 53%;
  left: -5%;

  .cls-1 {
    opacity: 0.6;
  }

  .cls-2 {
    fill: #fff;
  }

  .cls-3 {
    fill: #939598;
  }
`;

const Eyewear = () => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width="254.198"
      height="72.814"
      viewBox="0 0 254.198 72.814"
    >
      <g id="Group_118" data-name="Group 118" transform="translate(-204.728 -331.262)">
        <g id="Group_115" data-name="Group 115" className="cls-1">
          <path
            id="Path_141"
            data-name="Path 141"
            className="cls-2"
            d="M336.475,363.361l.146,17.918a12.846,12.846,0,0,0,8.651,12.027c15.58,5.412,51.565,14.089,101.294,2.519a12.792,12.792,0,0,0,9.853-12.429c.025-7-.015-16.912-.3-27.17a12.815,12.815,0,0,0-14.2-12.378c-21.125,2.292-62.456,6.342-92.733,6.582A12.821,12.821,0,0,0,336.475,363.361Z"
          />
        </g>
        <g id="Group_116" data-name="Group 116" className="cls-1">
          <path
            id="Path_142"
            data-name="Path 142"
            className="cls-2"
            d="M223.4,337.753c15.33,2.369,43.072,6.23,58.157,8.309a11.249,11.249,0,0,1,9.687,11.953c-.394,5.486-.876,12.276-1.28,18.223a11.257,11.257,0,0,1-11.386,10.494c-15.365-.2-44.034-1.775-64.306-10.07a11.287,11.287,0,0,1-6.86-12.489l3.2-17.34A11.251,11.251,0,0,1,223.4,337.753Z"
          />
        </g>
        <path
          id="Path_143"
          data-name="Path 143"
          className="cls-3"
          d="M398.21,404.076c-24.6,0-42.972-4.662-53.758-8.408A15.385,15.385,0,0,1,334.121,381.3l-.146-17.918a15.32,15.32,0,0,1,15.2-15.452c29.989-.238,70.816-4.217,92.484-6.567a15.315,15.315,0,0,1,16.968,14.794c.286,10.457.319,20.589.3,27.247a15.224,15.224,0,0,1-11.788,14.856A215.638,215.638,0,0,1,398.21,404.076Zm45.132-57.8a10.578,10.578,0,0,0-1.148.063c-21.76,2.36-62.776,6.356-92.983,6.6a10.32,10.32,0,0,0-10.236,10.411l.146,17.918a10.375,10.375,0,0,0,6.972,9.686c16.543,5.746,51.519,13.7,99.906,2.446a10.245,10.245,0,0,0,7.921-10c.022-6.622-.011-16.7-.3-27.093a10.317,10.317,0,0,0-10.283-10.023Z"
        />
        <path
          id="Path_144"
          data-name="Path 144"
          className="cls-3"
          d="M278.726,389.233h-.181c-15.487-.2-44.554-1.8-65.22-10.256a13.851,13.851,0,0,1-8.371-15.257l3.2-17.341a13.684,13.684,0,0,1,15.624-11.1h0c15.257,2.358,42.96,6.215,58.116,8.3a13.783,13.783,0,0,1,11.839,14.609c-.394,5.484-.875,12.27-1.279,18.212A13.767,13.767,0,0,1,278.726,389.233Zm-57.077-49.115a8.705,8.705,0,0,0-8.574,7.169l-3.2,17.34a8.833,8.833,0,0,0,5.347,9.722c19.9,8.142,48.26,9.687,63.392,9.883h.115a8.764,8.764,0,0,0,8.745-8.165c.4-5.95.886-12.742,1.28-18.233a8.771,8.771,0,0,0-7.535-9.3c-15.171-2.091-42.9-5.952-58.2-8.315h0A8.876,8.876,0,0,0,221.649,340.118Z"
        />
        <g id="Group_117" data-name="Group 117">
          <path
            id="Path_145"
            data-name="Path 145"
            className="cls-3"
            d="M347.029,360.364a3,3,0,0,1-2.849-2.064c-.263-.786-6.765-19.471-28.05-20.938-21.186-1.449-27.3,13.908-27.359,14.063a3,3,0,0,1-5.608-2.133c.075-.2,7.8-19.685,33.379-17.916,25.385,1.749,33.025,24.1,33.337,25.049a3,3,0,0,1-2.85,3.939Z"
          />
        </g>
      </g>
    </StyledSvg>
  );
};

export default React.memo(
  Eyewear,
  (prevProps, nextProps) => prevProps.fill === nextProps.fill
);
